import { render, staticRenderFns } from "./ItemChip.vue?vue&type=template&id=6ab52e24&scoped=true&"
import script from "./ItemChip.vue?vue&type=script&lang=ts&"
export * from "./ItemChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab52e24",
  null
  
)

export default component.exports